export const navWidth = '351px';
